/** Chiave del metadato che serve ad identificare tutti i selettori generati con context (createContextSelector)
 * 
 * Serve alla libreria in alcuni casi per distinguere i selettori con contesto da altri selettori parametrizzati
 */
export const NGRX_CONTEXT_SELECTOR_META = '@ngrx-context-selector';